import { UserIcon } from "@heroicons/react/24/solid";
import { ArrowDownTrayIcon } from "@heroicons/react/24/solid";
import { Link } from "react-router-dom";
import homeImg from "../../Images/homeImg.jpg";
import Header from "../Header/Header";
import { Typewriter } from "react-simple-typewriter";

const Home = () => {
  return (
    <div
      className="min-h-screen"
      style={{
        background: `url(${homeImg})`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <Header></Header>
      <div className="max-w-[1440px] mx-auto min-h-screen flex justify-end items-center p-2">
        <div className="text-center md:text-start lg:text-start md:w-[50%] lg:w-[50%]">
          <p>HI THERE !</p>
          <h2 className="uppercase mt-2 text-[orange] text-xl lg:text-4xl font-bold">
            I'M
            <Typewriter
              words={[
                " Ojit Deb Nath",
                " A MERN Stack Developer",
                " A Frontend Developer",
                " A React Developer",
              ]}
              loop={6}
              cursor
              cursorStyle="|"
              typeSpeed={60}
              deleteSpeed={50}
              delaySpeed={2000}
            />
          </h2>
          <p className="mt-5 lg:mt-2">
            I am a MERN Stack developer currently working with React and
            constantly trying to learn new technologies and always learning new
            technologies I like and feel very happy.
          </p>
          <div className="md:flex lg:flex mt-5 lg:mt-5">
            <Link
              to="/about"
              className=" uppercase flex justify-center hover:bg-[orange] duration-[0.4s] border-2 border-[orange] p-2 rounded-[20px] md:mb-0 mb-5 hover:text-black"
            >
              <div className="flex">
                <UserIcon className="w-6 h-6 mr-2"></UserIcon>
                <span>More about me</span>
              </div>
            </Link>

            <a
              className="uppercase flex justify-center hover:bg-[orange] duration-[0.4s] border-2 border-[orange] p-2 rounded-[20px] md:ml-4 lg:ml-4 hover:text-black"
              href="https://drive.google.com/file/d/1SNJyoOaXRb6PDk4zBfpqz_1l3IELofYM/view?usp=drive_link"
              target="_blank"
              rel="noreferrer"
              download="ojit.pdf"
            >
              <ArrowDownTrayIcon className="w-6 h-6 mr-2"></ArrowDownTrayIcon>
              <span>My Resume</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
